import styles from '../styles.module.scss';
import skeleton from './styles.module.scss';

export default function UserPaymentDetailsKycCheckSkeleton() {
  return (
    <div className={styles.container}>
      <div className={skeleton.lottie} />
      <div className={styles.container__wrapper}>
        <div className={styles.container__wrapper__title}>
          <div className={skeleton.title} />
        </div>
        <div className={styles.container__wrapper__description}>
          <div className={skeleton.description__container}>
            <div className={skeleton.description} />
            <div className={skeleton.description} />
            <div
              className={`${skeleton.description} ${skeleton['description--half']}`}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
